import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import GeodeticDatumList from './GeodeticDatumList';

const GeodeticDatums = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Datos Geodésicos' links={breadcrumbLinks} icon={'icon-map-pin'} />
					<GeodeticDatumList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default GeodeticDatums;
